import React from "react";
import { useState, useEffect } from 'react'; // Step 1: Import useEffect and useState
import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { AppBar, Box, CssBaseline, Toolbar, useMediaQuery, Typography } from '@mui/material';

// project imports
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import Header from "../../header/index";
import Sidebar from '../sidebar/sidebar';
// import Customization from '../Customization';
import navigation from '../menu-items/index';
import { drawerWidth } from '../../store/constant';
import { SET_MENU } from '../../store/actions';
// assets
// import { IconChevronRight } from '@tabler/icons';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

// styles
const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  ...theme.typography.mainContent,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  transition: theme.transitions.create(
    'margin',
    open
      ? {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen
        }
      : {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }
  ),
  [theme.breakpoints.up('md')]: {
    marginLeft: open ? 0 : -(drawerWidth - 20),
    width: `calc(100% - ${drawerWidth}px)`
  },
  [theme.breakpoints.down('md')]: {
    marginLeft: '20px',
    width: `calc(100% - ${drawerWidth}px)`,
    padding: '16px'
  },
  [theme.breakpoints.down('sm')]: {
    marginLeft: '10px',
    width: `calc(100% - ${drawerWidth}px)`,
    padding: '16px',
    marginRight: '10px'
  }
}));

const MainLayout = () => {
  const theme = useTheme();
  const matchDownMd = useMediaQuery(theme.breakpoints.down('md'));

  // Step 2: Add state variable for mobileOpen
  const [mobileOpen, setMobileOpen] = useState(false);
  // Handle left drawer
  const leftDrawerOpened = useSelector((state) => state.customization.opened);
  const dispatch = useDispatch();

  // Step 3: Use useEffect to update mobileOpen
  useEffect(() => {
    if (matchDownMd) {
      setMobileOpen(!leftDrawerOpened);
    } else {
      setMobileOpen(leftDrawerOpened);
    }
  }, [matchDownMd, leftDrawerOpened]);

  // Step 4: Modify handleLeftDrawerToggle to update mobileOpen
  const handleLeftDrawerToggle = () => {
    dispatch({ type: SET_MENU, opened: !leftDrawerOpened });
    setMobileOpen(!leftDrawerOpened); // Toggle mobileOpen
  };

  const bannerHeight = 0; // Height of the banner in pixels

  return (
    <Box sx={{ display: 'flex', paddingTop: `${bannerHeight}px` }}>
      <CssBaseline />
      
      {/* Welcome Back Banner */}
      {/* <Box 
        sx={{ 
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          background: 'linear-gradient(45deg, #FF6B6B 0%, #4ECDC4 25%, #45B7D1 50%, #96CEB4 75%, #FFEAA7 100%)',
          color: 'white',
          padding: '8px 16px',
          textAlign: 'center',
          zIndex: 9999, // Highest possible z-index
          height: `${bannerHeight}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box'
        }}
      >
        <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, fontSize: '14px', textShadow: '1px 1px 2px rgba(0,0,0,0.3)' }}>
          🎉 Website is back with it's original features! 🎉
        </Typography>
      </Box> */}
      
      {/* header */}
      <AppBar
        enableColorOnDark
        position="fixed"
        color="inherit"
        elevation={0}
        sx={{
          bgcolor: theme.palette.background.default,
          transition: leftDrawerOpened ? theme.transitions.create('width') : 'none',
          top: `${bannerHeight}px` // Push AppBar down by banner height
        }}
      >
        <Toolbar>
          <Header handleLeftDrawerToggle={handleLeftDrawerToggle} />
        </Toolbar>
      </AppBar>
      {/* drawer */}
      <Sidebar drawerOpen={!mobileOpen} drawerToggle={handleLeftDrawerToggle} />

      {/* main content */}
      <Main theme={theme} open={!mobileOpen}>
        {/* breadcrumb */}
        <Breadcrumbs separator={ChevronRightIcon} navigation={navigation} icon title rightAlign />
        <Outlet />
      </Main>
      {/* <Customization /> */}
    </Box>
  )
};

export default MainLayout;
